import React, { useEffect } from "react";

// Sends the browser to another origin. react-router's <Navigate> only handles
// in-app routes, so cross-origin destinations need a location replace.
const ExternalRedirect = ({ to }) => {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center gap-3 bg-white px-4 text-center">
      <p className="text-gray-600">Redirecting&hellip;</p>
      <a href={to} className="text-teal-600 hover:text-teal-700 underline">
        Continue to {to}
      </a>
    </div>
  );
};

export default ExternalRedirect;
